import type { ConsentSnapshot } from '@/Integrations/Consent/types';
import {
  createDefaultSnapshot,
  createSnapshot,
} from '@/Integrations/Consent/providers/nativeConsent/shared';

interface CookiebotConsent {
  necessary?: boolean;
  preferences?: boolean;
  statistics?: boolean;
  marketing?: boolean;
}

interface CookiebotGlobal {
  consent?: CookiebotConsent;
  regulations?: {
    gdprApplies?: boolean;
  };
}

function getCookiebot(): CookiebotGlobal | undefined {
  return (window as unknown as { Cookiebot?: CookiebotGlobal }).Cookiebot;
}

export function readCookiebotSnapshot(): ConsentSnapshot {
  const cookiebot = getCookiebot();
  if (!cookiebot) {
    return createDefaultSnapshot();
  }

  if (cookiebot.regulations?.gdprApplies === false) {
    return createSnapshot({ analytics: true, marketing: true }, cookiebot);
  }

  return createSnapshot(
    {
      analytics: cookiebot.consent?.statistics === true,
      marketing: cookiebot.consent?.marketing === true,
    },
    cookiebot,
  );
}

export function watchCookiebotConsent(onSnapshot: (snapshot: ConsentSnapshot) => void): () => void {
  const events = [
    'CookiebotOnConsentReady',
    'CookiebotOnAccept',
    'CookiebotOnDecline',
    'CookiebotOnLoad',
  ];
  const publish = () => onSnapshot(readCookiebotSnapshot());

  events.forEach((eventName) => {
    window.addEventListener(eventName, publish);
  });
  publish();

  return () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, publish);
    });
  };
}
